<template>
  <div>
    <div class="row settings-tabs full-height-tabs">
      <div class="col-lg-12 col-md-12">
        <vue-tabs
          ref="tabs"
          direction="vertical"
          class="row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs"
          @tab-change="handleTabChange"
        >
          <!-- TABLE ZONES -->
          <v-tab :title="$t('settingsPages.tableZones')" class="text-left">
            <keep-alive>
              <div v-if="isTableZones">
                <template v-if="selectedZone !== false">
                  <table-zone-form
                    @on-submit="onUserSubmit"
                    :callback="tableZoneUpdate"
                    :zoneId="selectedZone"
                  />
                </template>

                <template v-else>
                  <table-zone-list
                    ref="tableZone"
                    :isTable="isTableZones"
                    :callback="getZone"
                  />
                </template>
              </div>
            </keep-alive>
          </v-tab>

          <!-- TABLE MANAGER / QR MODULE -->
          <v-tab :title="$t('settingsPages.qrModule')" class="text-left">
            <keep-alive>
              <div v-if="isTableManager">
                <template v-if="selectedTable !== false">
                  <table-management-form
                    @on-submit="onUserSubmit"
                    :callback="tableManagementUpdate"
                    :tableId="selectedTable"
                    :posUsers="formattedUsers"
                    :showOnlineQr="true"
                  />
                </template>

                <template v-else>
                  <table-management-list
                    ref="tableManagement"
                    :isTable="isTableManager"
                    :callback="getTable"
                    :posUsers="formattedUsers"
                  />
                </template>
              </div>
            </keep-alive>
          </v-tab>

          <!-- SETTINGS TAB - Kiosk Colors -->
          <v-tab :title="$t('settingsPages.settings')" class="text-left">
            <keep-alive>
              <div>
                <kiosk-colors-card v-model="model" />
              </div>
            </keep-alive>
          </v-tab>
        </vue-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import TableZoneForm from '../Settings/TableZones/TableZonesForm.vue'
import TableZoneList from '../Settings/TableZones/TableZones.vue'

import TableManagementForm from '../Settings/TableManagement/TableManagementForm.vue'
import TableManagementList from '../Settings/TableManagement/TableManagement.vue'

import KioskColorsCard from 'src/components/UIComponents/KioskColorsCard.vue'

export default {
  components: {
    TableZoneForm,
    TableZoneList,
    TableManagementForm,
    TableManagementList,
    KioskColorsCard
  },

  data () {
    return {
      isTableZones: true,
      isTableManager: false,

      selectedZone: false,
      selectedTable: false,

      model: {},
      defaultData: {},
      websiteData: [],

      posUsers: []
    }
  },

  computed: {
    formattedUsers () {
      return this.posUsers.map(user => ({
        ...user,
        fullname: `${user.firstname} ${user.lastname}`
      }))
    }
  },

  created () {
    this.getModelData()
    this.getPosUsers()
  },

  methods: {
    handleTabChange (tabIndex, newTab) {
      this.isTableZones = false
      this.isTableManager = false

      this.$router.push(`${this.$route.path}?tabIndex=${tabIndex}`)

      switch (newTab.title) {
        case this.$t('settingsPages.tableZones'):
          this.isTableZones = true
          break

        case this.$t('settingsPages.qrModule'):
          this.isTableManager = true
          break

        default:
          this.isTableZones = true
          break
      }
    },

    getPosUsers () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/pos/all/users', 'GET', data, (response) => {
        if (response.status) {
          this.posUsers = response.data.pos_user
        }
      })
    },

    getModelData () {
      const token = this.$session.get('token')
      const companyID = this.$session.get('selectedCompany')

      this.apiRequest('/settings/general/' + companyID, 'GET', { token }, (response2) => {
        if (response2.status === true) {
          this.model = response2.data[0]

          this.model.selected_languages = response2.data[0].languages.map(lang => ({
            value: lang.id,
            label: lang.name
          }))
        }
      })

      this.apiRequest('/settings/website', 'GET', {
        token,
        company_id: companyID
      }, (response) => {
        if (response.status === true) {
          this.websiteData = response.data
        }
      })
    },

    onUserSubmit (model, isValid) {
    },

    tableManagementUpdate () {
      this.selectedTable = false

      if (this.$refs.tableManagement) {
        this.$refs.tableManagement.getData()
      }
    },

    tableZoneUpdate () {
      this.selectedZone = false

      if (this.$refs.tableZone) {
        this.$refs.tableZone.getData()
      }
    },

    getTable (id) {
      this.selectedTable = id
    },

    getZone (id) {
      this.selectedZone = id
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Qr/Qr.vue